export type PasswordIssue = "minLength" | "upper" | "digit" | "special";

export function validatePassword(pw: string) {
  const issues: PasswordIssue[] = [];
  if (pw.length < 6) issues.push("minLength");
  if (!/[A-Z]/.test(pw)) issues.push("upper");
  if (!/[0-9]/.test(pw)) issues.push("digit");
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(pw)) issues.push("special");
  return { valid: issues.length === 0, issues };
}

export function formatPasswordIssues(issues: PasswordIssue[]) {
  const map: Record<PasswordIssue, string> = {
    minLength: "At least 6 characters",
    upper: "At least one uppercase letter",
    digit: "At least one digit",
    special: "At least one special character",
  };
  return issues.map((i) => map[i]);
}
